export default __webpack_public_path__ + "static/mobile-banner-cce12d33d2fad8a998b28bf29376301d.jpg";